import axios from 'axios';
import auth from './auth';
import stages from './stages';
import applications from './applications';
import scheduler from './scheduler';
import notifications from './notifications';
import rejectionReasons from './rejection-reasons';
import data from './data';
import todos from './todos';
import metrics from './metrics';
import users from './users';
import vettingPlans from './vettingPlans';
import interviewGroups from './interviewGroups';
import roles from './roles';

axios.defaults.baseURL = import.meta.env.VITE_API;

const api = {
  auth,
  stages,
  applications,
  scheduler,
  notifications,
  rejectionReasons,
  data,
  todos,
  metrics,
  users,
  vettingPlans,
  interviewGroups,
  roles,
};

export default api;
